import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailApplicationComponent } from './detail-application.component';
import { DetailApplicationRoutingModule } from './detail-application-routing.module';
import { BaseDataComponent } from './component/base-data/base-data.component';
import { SendOrdersComponent } from './component/send-orders/send-orders.component';
import { TaskAssignComponent } from './component/task-assign/task-assign.component';
import { EditableTaskComponent } from './component/task-assign/component/editable-task/editable-task.component';
import { DisplayTaskComponent } from './component/task-assign/component/display-task/display-task.component';
import { AppointTaskComponent } from './component/appoint-task/appoint-task.component';
import { AssignStatusComponent } from './component/assign-status/assign-status.component';
import { BidTableComponent } from './component/bid/bid-table/bid-table.component';
import { BidFormComponent } from './component/bid/bid-form/bid-form.component';
import { MakeBidComponent } from './component/make-bid/make-bid.component';
import { MakeBudgetEstimatesComponent } from './component/make-budget-estimates/make-budget-estimates.component';
import { ReviewResultComponent} from './component/review-result/review-result.component';
import { UploadQuotationComponent } from './component/upload-quotation/upload-quotation.component';
import { PrpoInfoComponent } from './component/prpo-info/prpo-info.component';

@NgModule({
  declarations: [
    DetailApplicationComponent,
    BaseDataComponent,
    SendOrdersComponent,
    TaskAssignComponent,
    EditableTaskComponent,
    DisplayTaskComponent,
    AppointTaskComponent,
    AssignStatusComponent,
    BidFormComponent,
    BidTableComponent,
    MakeBidComponent,
    MakeBudgetEstimatesComponent,
    ReviewResultComponent,
    UploadQuotationComponent,
    PrpoInfoComponent,
  ],
  imports: [
    CommonModule,
    DetailApplicationRoutingModule,
    SharedModule
  ]
})
export class DetailApplicationModule { }
